import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Drawer, DrawerClose, DrawerContent, DrawerDescription, DrawerHeader, DrawerTitle } from '../../../../empreenderUI/ui/Drawer';
import { Button } from '../../../../empreenderUI/ui/Button';
import Input from '../../../../empreenderUI/ui/Input';
import { translations } from '../../../../utils/language';

const ModalRenomearMidia = (props) => {
  const language = useSelector((state) => state.reducerLanguage);
  const isUrl = props.item?.type === 'url';
  const fileExt = props.item?.media_name?.split('.')?.pop() || '';

  const [nameMidia, setNameMidia] = useState(isUrl ? props.item.media : props?.item?.media_name?.replace(/\.[^/.]+$/, ''));
  const [url, setUrl] = useState(props.item?.media || '');
  const [nameUrl, setNameUrl] = useState(props.item?.media_name || '');

  useEffect(() => {
    if (!props.item) return;
    const urlType = props.item.type === 'url';
    setNameMidia(urlType ? props.item.media : props.item?.media_name?.replace(/\.[^/.]+$/, '') || '');
    setUrl(props.item.media || '');
    setNameUrl(props.item.media_name || '');
  }, [props.item, props.visible]);

  const closeDrawer = () => {
    props.setVisible(false);
  };

  const handleOpenChange = (open) => {
    if (!open) closeDrawer();
  };

  const rename = () => {
    if (isUrl) {
      props.renameMedia(nameUrl, url);
    } else {
      props.renameMedia(`${nameMidia}.${fileExt}`, '');
    }
  };

  const canSubmit = isUrl ? nameUrl !== '' && url !== '' : nameMidia !== '';

  return (
    <Drawer open={!!props.visible} onOpenChange={handleOpenChange} direction='right'>
      <DrawerContent className='!w-[min(420px,100vw)] !max-w-[min(420px,100vw)] !h-full !max-h-[100dvh] border-l border-gray-200 p-0 flex flex-col overflow-hidden bg-white'>
        <DrawerHeader className='relative shrink-0 space-y-0 bg-white px-6 pt-6 pb-2'>
          <div className='flex items-start justify-between gap-3 pr-10'>
            <div className='min-w-0 space-y-1'>
              <DrawerTitle className='text-xl font-bold tracking-tight text-gray-900'>{translations['medias-renomear-midia'][language.data]}</DrawerTitle>
              <DrawerDescription className='text-sm font-medium text-gray-500 truncate' title={props.item?.media_name}>
                {props.item?.media_name || (isUrl ? 'URL' : translations['medias-renomear-placeholder'][language.data])}
              </DrawerDescription>
            </div>
          </div>
          <DrawerClose asChild>
            <button type='button' className='absolute right-4 top-4 inline-flex size-8 items-center justify-center rounded-lg bg-gray-100 text-gray-700 transition-colors hover:bg-gray-200' aria-label={translations['common-close'][language.data]}>
              <XMarkIcon className='size-5' />
            </button>
          </DrawerClose>
        </DrawerHeader>

        <div className='flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto px-6 py-4 custom-scroll'>
          {isUrl ? (
            <>
              <div className='flex flex-col gap-1.5'>
                <label className='text-xs font-medium text-gray-500'>{translations['medias-renomear-nome-url'][language.data]}</label>
                <Input type='text' value={nameUrl} onChange={(e) => setNameUrl(e.target.value)} placeholder={translations['medias-renomear-nome-url'][language.data]} />
              </div>
              <div className='flex flex-col gap-1.5'>
                <label className='text-xs font-medium text-gray-500'>URL</label>
                <Input type='text' value={url} onChange={(e) => setUrl(e.target.value)} placeholder='https://' />
              </div>
            </>
          ) : (
            <div className='flex flex-col gap-1.5'>
              <label className='text-xs font-medium text-gray-500'>{translations['Nome'][language.data]}</label>
              <div className='flex items-center gap-2'>
                <Input
                  type='text'
                  value={nameMidia}
                  onChange={(e) => setNameMidia(e.target.value)}
                  placeholder={translations['medias-renomear-placeholder'][language.data]}
                  className='flex-1'
                />
                {fileExt ? <span className='shrink-0 rounded-lg border border-gray-200 bg-gray-50 px-2.5 py-2 text-sm font-medium text-gray-600'>.{fileExt}</span> : null}
              </div>
            </div>
          )}

          <div className='mt-auto flex justify-end pt-2'>
            <Button type='button' disabled={!canSubmit} onClick={rename} className='bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-50'>
              {translations['medias-salvar'][language.data]}
            </Button>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
};

export default ModalRenomearMidia;
